<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="37.725"
    height="38.71"
    viewBox="0 0 37.725 38.71"
  >
    <g
      id="Group_5360"
      data-name="Group 5360"
      transform="translate(-85.089 -259.291)"
    >
      <path
        id="Path_49"
        data-name="Path 49"
        d="M-3558.982,10363.036h-11.5v-13.313h-5.429l16.928-15.378Z"
        transform="translate(3661 -10065.035)"
        class="primary"
      />
      <path
        id="Path_50"
        data-name="Path 50"
        d="M-3557.917,10334.345h6.21l1.742,1.7-1.742,1.573h-6.21Z"
        transform="translate(3661 -10065.035)"
        fill="#005900"
      />
      <path
        id="Path_51"
        data-name="Path 51"
        d="M-3557.917,10338.548h7.971l1.76,1.78-1.76,1.532h-7.971Z"
        transform="translate(3661 -10065.035)"
        fill="#109911"
      />
      <path
        id="Path_53"
        data-name="Path 53"
        d="M-3567.141,10341.86v-5.552h3.277v2.665Z"
        transform="translate(3661 -10065.035)"
        class="primary"
      />
      <path
        id="Path_52"
        data-name="Path 52"
        d="M-3557.917,10342.775h9.722l1.808,1.787-1.808,1.471h-9.722Z"
        transform="translate(3661 -10065.035)"
        fill="#91c883"
      />
      <path
        id="Path_55"
        data-name="Path 55"
        d="M-3557.917,10342.775h11.59l2.156,1.787-2.156,1.471h-11.59Z"
        transform="translate(3661 -10060.852)"
        fill="#c6e984"
      />
      <path
        id="Path_56"
        data-name="Path 56"
        d="M-3557.918,10342.775H-3544l2.589,1.787-2.589,1.471h-13.919Z"
        transform="translate(3661 -10056.68)"
        fill="#edf458"
      />
      <path
        id="Path_57"
        data-name="Path 57"
        d="M-3557.918,10342.775h15.254l2.837,1.787-2.837,1.471h-15.254Z"
        transform="translate(3661 -10052.68)"
        fill="#ff9500"
      />
      <path
        id="Path_58"
        data-name="Path 58"
        d="M-3557.917,10342.775h16.637l3.094,1.787-3.094,1.471h-16.637Z"
        transform="translate(3661 -10048.504)"
        fill="#eb4a21"
      />
      <path
        id="Path_54"
        data-name="Path 54"
        d="M-3565.209,10341.051h1.253l-.253-.518-.127-.736v-1.883h.627l.71-.109.833-.217.621-.223.792-.465.389-.416.358-.441.31-.437.281-.584.115-.52.153-.6v-2.527l.131-.518v-.6l.257-.361.289-.426.24-.256.313-.145h-1.23l-.549.145-.546.1-.511.152-.523.146-.542.113-.547.166-.633.361-.71.229-.627.264-.408.236-.465.391-.507.271-.707.656-.26.432-.28.713-.128.455v.6l.128.52.28.787.26.676.268.416.232.256.206.209.186-.672.206-.461.116-.424.242-.408.223-.379.267-.316.268-.2.371-.275.556-.324.663-.455-.5.455-.375.6-.213.2-.36.465-.267.436-.272.627-.136.461-.223.895-.242,1.014v2.449Z"
        transform="translate(3659.64 -10069.777)"
        class="secondary"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.primary {
  fill: $primary-color;
}
.secondary {
  fill: $secondary-color;
}
</style>
